import React from 'react'
import { BsBook } from 'react-icons/bs'
import { FaLocationPin } from 'react-icons/fa6'
import TeacherMsgCard from './TeacherMsgCard'
import { useTranslation } from 'react-i18next'

function TeacherMessage() {
  const { t } = useTranslation();
  return (
    <>
    <div>
     <div className="flex items-center xl:p-5 sm:p-0 justify-center">
       <div className="w-full border rounded-3xl shadow-xl p-5">

       <div>
         <div className="flex items-center xl:p-5 sm:p-0 justify-center">
                <div className="w-full  xl:p-5 sm:p-0">
                    <div className="p-5"><TeacherMsgCard /></div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 ">
                        <div className="   md:px-4 md:py-4 col-span-1 sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-2 space-y-5">
                            <div className="border rounded-3xl shadow-xl p-5">
                                <p className="text-2xl font-semibold mb-3">{t("teacherDash.teacherMessage.about")}</p>
                                <p className="text-xs font-light">{t("teacherDash.teacherMessage.aboutText")}</p>
                            </div>
                            <div className="border rounded-3xl shadow-xl p-5">
                                <p className="text-2xl font-semibold mb-3">{t("teacherDash.teacherMessage.tuitionLocation")}</p>
                                <div>
                                    <p className="text-base font-semibold mb-3 flex items-center space-x-1"><FaLocationPin className='text-lg' /><span>{t("teacherDash.common.address")}</span>  </p>
                                    <p className='text-sm font-semibold'>{t("teacherDash.teacherMessage.mainAddressLabel")}</p>
                                    <p className="text-sm font-light mb-3">{t("teacherDash.teacherMessage.addressText")}</p>
                                </div>
                            </div>
                        </div>
                        <div className="  col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 md:px-4 md:py-4 space-y-5 md:mt-3 mt-6 p-5 min-h-screen border rounded-3xl shadow-xl">
                            <div><p className="text-2xl font-semibold mb-2">{t("teacherDash.teacherMessage.subjectsHeading")}</p></div>
                            <div>
                                <div><p className='flex items-center text-lg font-semibold space-x-2'><BsBook className='text-lg font-semibold' /><span>{t("teacherDash.teacherMessage.sampleSubjectMath")}</span></p></div>
                                <div><p className='text-sm font-semibold'>{t("teacherDash.teacherMessage.sampleHours")}</p></div>
                            </div>
                            <div>
                                <div><p className='flex items-center text-lg font-semibold space-x-2'><BsBook className='text-lg font-semibold' /><span>{t("teacherDash.teacherMessage.sampleSubjectChemistry")}</span></p></div>
                                <div><p className='text-sm font-semibold'>{t("teacherDash.teacherMessage.sampleHours")}</p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
       
       </div>
     </div>
   </div>
   </>
  )
}

export default TeacherMessage
